import type { SchrijvenScore } from "@a2/core";
import { totalScore, bandFor, BAND_LABEL, SCHRIJVEN_RUBRIC } from "@a2/core";
import { FeedbackBubble } from "../feedback/FeedbackBubble";

export interface SchrijvenFeedbackBubbleProps {
  score: SchrijvenScore;
  tutorParagraph: string;
  tutorParagraphTranslation?: string | null;
  bullets?: { text: string; covered: boolean }[];
}

export function SchrijvenFeedbackBubble(p: SchrijvenFeedbackBubbleProps) {
  const band = bandFor(p.score);
  const total = totalScore(p.score);
  const max = SCHRIJVEN_RUBRIC.reduce((sum, c) => sum + c.max, 0);

  return (
    <FeedbackBubble
      band={band}
      bandLabel={BAND_LABEL[band]}
      total={total}
      max={max}
      tutorParagraph={p.tutorParagraph}
      tutorParagraphTranslation={p.tutorParagraphTranslation}
      criteria={SCHRIJVEN_RUBRIC.map((c) => ({
        key: c.key,
        label: c.label,
        value: (p.score as unknown as Record<string, number>)[c.key] ?? 0,
        max: c.max,
      }))}
      extras={
        p.bullets && p.bullets.length > 0 ? (
          <ul className="space-y-1 mt-2">
            {p.bullets.map((b, i) => (
              <li key={i} className="flex items-start gap-2 text-xs text-[var(--ink-muted)]">
                <span
                  className="mt-1 inline-block w-1.5 h-1.5 rounded-full flex-shrink-0"
                  style={{ background: b.covered ? "var(--pass)" : "var(--border)" }}
                />
                <span>{b.text}</span>
              </li>
            ))}
          </ul>
        ) : null
      }
    />
  );
}
